
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCurrent2 as ObiCurrent2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-current-2.js';
 
 
 

 
 export const ObiCurrent2 = createComponent({
   react: React,
   tagName: 'obi-current-2',
   elementClass: ObiCurrent2Element,
   events: {
     
   }
  });
 
 